'use client';

import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const CommitIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  /* width: 100%; */
  gap: 50px;
`;
